import React from "react";
import ReactDOM from "react-dom/client";
import MainRouter from "./router";
import { BrowserRouter } from "react-router-dom";
import "./shared/styles/global.scss";
import reportWebVitals from "./reportWebVitals";
import "react-toastify/dist/ReactToastify.css";

ReactDOM.hydrateRoot(
  document.getElementById("root") as HTMLElement,
  <BrowserRouter>
    <MainRouter />
  </BrowserRouter>,
);

reportWebVitals();
